import React from 'react';
import {
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
  Chip,
  Box,
  Divider,
} from '@mui/material';
import { 
  ArrowUpward, 
  ArrowDownward,
  Receipt,
} from '@mui/icons-material';
import { formatCurrency, formatDate } from '../../utils/formatters';

const RecentTransactions = ({ transactions }) => {
  if (!transactions || transactions.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Typography color="text.secondary">No recent transactions</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Recent Transactions
      </Typography>
      <List sx={{ overflow: 'auto', maxHeight: 320 }}>
        {transactions.slice(0, 10).map((transaction, index) => (
          <React.Fragment key={transaction.id}>
            <ListItem alignItems="flex-start">
              <ListItemAvatar>
                <Avatar sx={{ 
                  bgcolor: transaction.paid_in > 0 ? 'success.light' : 'error.light',
                  color: transaction.paid_in > 0 ? 'success.dark' : 'error.dark',
                }}>
                  {transaction.paid_in > 0 ? <ArrowUpward /> : <ArrowDownward />}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="body2" fontWeight="medium">
                      {transaction.receipt_no}
                    </Typography>
                    <Typography variant="body2" sx={{ 
                      color: transaction.paid_in > 0 ? 'success.main' : 'error.main',
                      fontWeight: 'bold',
                    }}>
                      {transaction.paid_in > 0 
                        ? `+${formatCurrency(transaction.paid_in)}`
                        : `-${formatCurrency(transaction.withdrawn)}`
                      }
                    </Typography>
                  </Box>
                }
                secondary={
                  <Box>
                    <Typography variant="caption" color="text.secondary" display="block">
                      {formatDate(transaction.completion_time)}
                    </Typography>
                    <Typography variant="caption" display="block" noWrap>
                      {transaction.details.length > 40 
                        ? `${transaction.details.substring(0, 40)}...` 
                        : transaction.details
                      }
                    </Typography>
                    <Chip
                      label={transaction.transaction_type}
                      size="small"
                      sx={{ 
                        mt: 0.5,
                        backgroundColor: transaction.paid_in > 0 ? '#e8f5e9' : '#ffebee',
                        color: transaction.paid_in > 0 ? '#2e7d32' : '#c62828',
                        fontSize: '0.65rem',
                      }}
                    />
                  </Box>
                }
              />
            </ListItem>
            {index < transactions.slice(0, 10).length - 1 && <Divider variant="inset" component="li" />}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};

export default RecentTransactions;